import {onCheckoutSubmit, onCheckoutSubmitError} from './checkout';
import {cleanupTransactionFields, createPaymentTransaction, insertTransactionFields, updatePaymentTransaction} from './transaction';
import {insertCaptchaFields, cleanupCaptchaFields} from './botProtection';
import {type TokenizeFunctions, type PeachPayCheckoutData} from './types';

declare const peachpay_checkout_data: PeachPayCheckoutData;

async function initPeachPayPayments($checkoutForm: HTMLFormElement): Promise<void> {
	const tokenizeFunctions: TokenizeFunctions = {
		peachpay_purchase_order: payment,
	};

	onCheckoutSubmit($checkoutForm, tokenizeFunctions);

	onCheckoutSubmitError($checkoutForm, tokenizeFunctions, async (transactionId, errors) => {
		if (!transactionId) {
			return;
		}

		try {
			await updatePaymentTransaction(transactionId, {
				paymentStatus: 'unperformed',
				orderStatus: 'creationfailed',
				note: errors.join(' '),
			});
		} catch {
			// Do no harm.
		}
	});
}

async function payment($form: HTMLFormElement, gateway: string) {
	cleanupTransactionFields();
	cleanupCaptchaFields();

	const transactionId = await createPaymentTransaction(gateway);
	if (!transactionId) {
		return false;
	}

	insertTransactionFields($form, transactionId);
	await insertCaptchaFields($form);

	return true;
}

export {
	initPeachPayPayments,
};
